import { render, staticRenderFns } from "./ChatMessageSend.vue?vue&type=template&id=82c2b266&"
import script from "./ChatMessageSend.vue?vue&type=script&lang=js&"
export * from "./ChatMessageSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports